import { useEffect } from 'react';

import { sendGAEvent } from 'utils/tracking';

const useTracking = (isPageReady: boolean) => {
  useEffect(() => {
    if (!isPageReady) {
      return;
    }
    sendGAEvent({ event: 'page_loaded', category: 'parking-sip', label: 'parking_sip_loaded' });
  }, [isPageReady]);
};

export default useTracking;
